import { render } from "./PackageInfo.vue?vue&type=template&id=37786d9d&scoped=true"
import script from "./PackageInfo.vue?vue&type=script&lang=ts"
export * from "./PackageInfo.vue?vue&type=script&lang=ts"

import "./PackageInfo.vue?vue&type=style&index=0&id=37786d9d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37786d9d"

export default script